import * as React from 'react';

import { useEventListener } from '../events/useEventListener';

import { VALID_QUERY_INPUT } from './useMediaQuery.type';
import { VALID_MEDIA_QUERY_INPUTS } from './useMediaQuery.utils';

export const useMediaQuery = (inputQuery: VALID_QUERY_INPUT): boolean => {
  const query = VALID_MEDIA_QUERY_INPUTS[inputQuery];
  const matchMedia = window.matchMedia(query);
  const [ match, setMatch ] = React.useState(matchMedia.matches);

  useEventListener('resize', () => setMatch(matchMedia.matches), window);

  return match;
};
